import {
  primaryColor,
  cardTitle,
  dangerColor,
  whiteColor,
  grayColor,
  blackColor,
  hexToRgb
} from 'assets/jss/material-dashboard-pro-react.js'
import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js'
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js'

const validationFormsStyle = {
  nitorLogo: {
    float: 'right',
    height: '40px'
  },
  nitorConnectLogo: {
    height: '150px'
  },
  documentNumber: {
    backgroundColor: primaryColor[0],
    margin: '0px auto',
    textAlign: 'center',
    color: whiteColor
  },
  documentNumberText: {
    padding: '20px 0',
    fontWeight: 'bolder'
  },
  detailsButton: {
    float: 'right',
    textTransform: 'none',
    fontSize: '20px'
  },
  verticalCenter: {
    marginTop: '20%'
  },
  detailsHeader: {
    fontWeight: 'bold'
  },
  listItem: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  additionalButton: {
    float: 'right',
    textTransform: 'none',
    fontSize: '20px',
    textDecoration: 'underline'
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  formCategory: {
    marginBottom: '0',
    color: grayColor[0],
    fontSize: '14px',
    padding: '10px 0 10px'
  },
  center: {
    textAlign: 'center'
  },
  justifyContentCenter: {
    justifyContent: 'center'
  },
  registerButton: {
    float: 'right'
  },
  danger: {
    color: dangerColor[0] + '!important'
  },
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  label: {
    cursor: 'pointer',
    paddingLeft: '0',
    color: 'rgba(' + hexToRgb(blackColor) + ', 0.26)',
    fontSize: '14px',
    lineHeight: '1.428571429',
    fontWeight: '400',
    display: 'inline-flex'
  },
  mrAuto: {
    marginRight: 'auto'
  },
  mlAuto: {
    marginLeft: 'auto'
  }
}

export default validationFormsStyle
